import { HttpContextToken } from '@angular/common/http';

export const IGNORAR_LOADING: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);